'use client'

import React from 'react';
import styles from './styles.module.scss';
import Link from 'next/link';
import SvgCookie from '@/src/assets/svgs/collection/cookie.svg'


export default function AllowCookiesLayout() {

    const chromeLink = 'https://support.google.com/accounts/answer/61416?hl=pt-BR&co=GENIE.Platform%3DAndroid'
    const safariLink = 'https://www.apple.com/br/legal/privacy/br/cookies/#:~:text=No%20iPad%2C%20iPhone%20ou%20iPod,a%20determinadas%20partes%20desses%20sites.'

    return (
        <div className={styles.container}>
            <div className={styles.svgArea}>
                <SvgCookie />
            </div>
            <div className={styles.infos}>
                <p className={`${styles.subtitle} font-lg`}>
                    Ops! Parece que os cookies estão desativados.
                </p>
                <p className={`${styles.description} font-xmd`}>
                    Para continuar aproveitando todos os recursos, ative os cookies nas configurações do seu navegador ou verifique se há alguma extensão com bloqueadores.
                </p>

                <span>
                    Como ativar os cookies em <Link className={styles.link} href={chromeLink} target='_blank'>Chrome</Link> ou <Link className={styles.link} href={safariLink} target='_blank'>Safari</Link>.
                </span>
            </div>
        </div>
    );
}
